import { render } from "./WishAlsoTagged.vue?vue&type=template&id=fd639b64&scoped=true"
import script from "./WishAlsoTagged.vue?vue&type=script&lang=js"
export * from "./WishAlsoTagged.vue?vue&type=script&lang=js"

import "./WishAlsoTagged.vue?vue&type=style&index=0&id=fd639b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd639b64"]])

export default __exports__